// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yegEisB5e7MMDlLM {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 100px;
}

.yegEisB5e7MMDlLM h1 {
  text-align: center;
  margin: 65px 0 45px;
}

.KyVUxALIlhcGbZe2 {
  display: flex;
  align-items: center;
  margin-bottom: 45px;
}

.KyVUxALIlhcGbZe2 p {
  margin: 0;
  margin-right: 15px;
  text-transform: uppercase;
  flex-shrink: 0;
  color: #8b7756;
}

.KyVUxALIlhcGbZe2 div {
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background-color: #8b7756;
}

.p7G5T4j0z6YTLMuK {
  display: flex;
  flex-wrap: wrap;
  width: 1295px;
  gap: 55px;
  margin: 0 auto;
}

.jpwGTMJJ2YwLx3EX {
  width: 619px;
  height: 717px;
  background-color: #f9f9f9;
  border: 1px solid #20336c;
  border-radius: 40px;
  overflow: hidden;
  box-shadow: 8px 8px 0 0 #20336c;
}

.JOjqtd8_GYg8gsqP {
  height: 165px;
  background-color: #ffe3d2;
  padding: 30px 50px;
}

.GSFBjk1LoEkfbDX1 {
  background-color: #b7dec0;
}

.xsGUZDdSh8YMFi6v {
  position: relative;
  display: flex;
  justify-content: center;
}

.xsGUZDdSh8YMFi6v p {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  font-size: 20px;
}

.xsGUZDdSh8YMFi6v i {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 26px;
}

.xsGUZDdSh8YMFi6v h2 {
  margin: 0;
  font-size: 32px;
}

.vY7AERwjs064uFo6 {
  text-align: center;
  margin-top: 35px;
  font-size: 20px;
}

.CFQepV4sqpE4PLG2 {
  margin-top: 50px;
  margin-bottom: 50px;
  padding: 0 50px;
  height: 450px;
  overflow: auto;
}

.PEI1FLnRsgc455po {
  display: flex;
  margin-bottom: 38px;
  font-size: 20px;
}

.PEI1FLnRsgc455po.C9R_TqzgtEsdH0Zn > div:nth-child(1) {
  color: #c45200;
}

.PEI1FLnRsgc455po > div:nth-child(1) {
  flex-shrink: 0;
  width: 185px;
  margin-right: 40px;
  font-weight: bold;
  color: #001657;
}

.PEI1FLnRsgc455po > div:nth-child(2) {
  text-transform: uppercase;
}

.E6tZ5LEPP8yJSO2H {
  background-color: #e8f4ff;
  border-radius: 12px;
  padding: 10px 14px;
  margin-left: -14px;
  margin-right: -14px;
}

.QcLavE1FU_8dOJLl {
  font-size: 32px !important;
  font-weight: bold;
  letter-spacing: 6px;
  color: #20336c;
}

@media screen and (max-width: 768px) {
  .QcLavE1FU_8dOJLl {
    font-size: 22px !important;
    letter-spacing: 4px;
  }
}

.Ci4jPHGRgYxBPkhm {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 85px;
  margin-bottom: 47px;
}

@media screen and (max-width: 1440px) {
  .p7G5T4j0z6YTLMuK {
    width: 618px;
  }

  .KyVUxALIlhcGbZe2 {
    width: 80%;
    margin: 0 auto 45px;
  }

  .Ci4jPHGRgYxBPkhm {
    justify-content: center;
  }

  .jpwGTMJJ2YwLx3EX {
    height: auto;
  }

  .CFQepV4sqpE4PLG2 {
    height: auto;
  }

  .yegEisB5e7MMDlLM {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .KyVUxALIlhcGbZe2 {
    width: 90%;
  }

  .yegEisB5e7MMDlLM h1 {
    margin: 26px 0 34px;
    font-size: 20px;
  }

  .KyVUxALIlhcGbZe2 p {
    font-size: 10px;
    font-weight: 500;
  }

  .p7G5T4j0z6YTLMuK {
    width: 100%;
    justify-content: center;
    gap: 27px;
  }

  .jpwGTMJJ2YwLx3EX {
    width: 297px;
    box-shadow: 4px 4px 0 0 #20336c;
    border-radius: 20px;
  }

  .JOjqtd8_GYg8gsqP {
    height: 66px;
    padding: 15px;
  }

  .xsGUZDdSh8YMFi6v p {
    font-size: 10px;
  }

  .xsGUZDdSh8YMFi6v h2 {
    font-size: 16px;
  }

  .xsGUZDdSh8YMFi6v i {
    font-size: 15px;
  }

  .vY7AERwjs064uFo6 {
    margin-top: 6px;
    font-size: 10px;
  }

  .CFQepV4sqpE4PLG2 {
    margin-top: 25px;
    margin-bottom: 25px;
    padding: 0 25px;
  }

  .PEI1FLnRsgc455po {
    margin-bottom: 18px;
    font-size: 10px;
  }

  .PEI1FLnRsgc455po > div:nth-child(1) {
    width: 75px;
    margin-right: 20px;
  }

  .Ci4jPHGRgYxBPkhm {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/OrderStatusPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".pageWrapper {\r\n  width: 1400px;\r\n  margin: 0 auto;\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.pageWrapper h1 {\r\n  text-align: center;\r\n  margin: 65px 0 45px;\r\n}\r\n\r\n.divider {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 45px;\r\n}\r\n\r\n.divider p {\r\n  margin: 0;\r\n  margin-right: 15px;\r\n  text-transform: uppercase;\r\n  flex-shrink: 0;\r\n  color: #8b7756;\r\n}\r\n\r\n.divider div {\r\n  width: 100%;\r\n  height: 2px;\r\n  border-radius: 2px;\r\n  background-color: #8b7756;\r\n}\r\n\r\n.ordersContainer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 1295px;\r\n  gap: 55px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.orderCard {\r\n  width: 619px;\r\n  height: 717px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #20336c;\r\n  border-radius: 40px;\r\n  overflow: hidden;\r\n  box-shadow: 8px 8px 0 0 #20336c;\r\n}\r\n\r\n.cardHeader {\r\n  height: 165px;\r\n  background-color: #ffe3d2;\r\n  padding: 30px 50px;\r\n}\r\n\r\n.completed {\r\n  background-color: #b7dec0;\r\n}\r\n\r\n.headerRow {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.headerRow p {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  margin: 0;\r\n  font-size: 20px;\r\n}\r\n\r\n.headerRow i {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 26px;\r\n}\r\n\r\n.headerRow h2 {\r\n  margin: 0;\r\n  font-size: 32px;\r\n}\r\n\r\n.status {\r\n  text-align: center;\r\n  margin-top: 35px;\r\n  font-size: 20px;\r\n}\r\n\r\n.cardDetails {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding: 0 50px;\r\n  height: 450px;\r\n  overflow: auto;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  margin-bottom: 38px;\r\n  font-size: 20px;\r\n}\r\n\r\n.row.allergies > div:nth-child(1) {\r\n  color: #c45200;\r\n}\r\n\r\n.row > div:nth-child(1) {\r\n  flex-shrink: 0;\r\n  width: 185px;\r\n  margin-right: 40px;\r\n  font-weight: bold;\r\n  color: #001657;\r\n}\r\n\r\n.row > div:nth-child(2) {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.customerCodeRow {\r\n  background-color: #e8f4ff;\r\n  border-radius: 12px;\r\n  padding: 10px 14px;\r\n  margin-left: -14px;\r\n  margin-right: -14px;\r\n}\r\n\r\n.customerCode {\r\n  font-size: 32px !important;\r\n  font-weight: bold;\r\n  letter-spacing: 6px;\r\n  color: #20336c;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .customerCode {\r\n    font-size: 22px !important;\r\n    letter-spacing: 4px;\r\n  }\r\n}\r\n\r\n.showHistoryButton {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  margin-top: 85px;\r\n  margin-bottom: 47px;\r\n}\r\n\r\n@media screen and (max-width: 1440px) {\r\n  .ordersContainer {\r\n    width: 618px;\r\n  }\r\n\r\n  .divider {\r\n    width: 80%;\r\n    margin: 0 auto 45px;\r\n  }\r\n\r\n  .showHistoryButton {\r\n    justify-content: center;\r\n  }\r\n\r\n  .orderCard {\r\n    height: auto;\r\n  }\r\n\r\n  .cardDetails {\r\n    height: auto;\r\n  }\r\n\r\n  .pageWrapper {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .divider {\r\n    width: 90%;\r\n  }\r\n\r\n  .pageWrapper h1 {\r\n    margin: 26px 0 34px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .divider p {\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .ordersContainer {\r\n    width: 100%;\r\n    justify-content: center;\r\n    gap: 27px;\r\n  }\r\n\r\n  .orderCard {\r\n    width: 297px;\r\n    box-shadow: 4px 4px 0 0 #20336c;\r\n    border-radius: 20px;\r\n  }\r\n\r\n  .cardHeader {\r\n    height: 66px;\r\n    padding: 15px;\r\n  }\r\n\r\n  .headerRow p {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .headerRow h2 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .headerRow i {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .status {\r\n    margin-top: 6px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .cardDetails {\r\n    margin-top: 25px;\r\n    margin-bottom: 25px;\r\n    padding: 0 25px;\r\n  }\r\n\r\n  .row {\r\n    margin-bottom: 18px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .row > div:nth-child(1) {\r\n    width: 75px;\r\n    margin-right: 20px;\r\n  }\r\n\r\n  .showHistoryButton {\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `yegEisB5e7MMDlLM`;
export var divider = `KyVUxALIlhcGbZe2`;
export var ordersContainer = `p7G5T4j0z6YTLMuK`;
export var orderCard = `jpwGTMJJ2YwLx3EX`;
export var cardHeader = `JOjqtd8_GYg8gsqP`;
export var completed = `GSFBjk1LoEkfbDX1`;
export var headerRow = `xsGUZDdSh8YMFi6v`;
export var status = `vY7AERwjs064uFo6`;
export var cardDetails = `CFQepV4sqpE4PLG2`;
export var row = `PEI1FLnRsgc455po`;
export var allergies = `C9R_TqzgtEsdH0Zn`;
export var customerCodeRow = `E6tZ5LEPP8yJSO2H`;
export var customerCode = `QcLavE1FU_8dOJLl`;
export var showHistoryButton = `Ci4jPHGRgYxBPkhm`;
export default ___CSS_LOADER_EXPORT___;
